import React, { useState } from 'react'
import { WidgetContent, Toggle, TextField, Select } from '@duik/it'
import CreateNewModal from '../UI/CreateNewModal'
import { ModalButton } from '../UI/ModalButton'
import FormInputGroup from '../UI/FormInputGroup'
import 'react-datepicker/dist/react-datepicker.css'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'

const CreateOrEditHaul = ({
  viewStep,
  projectList,
  materialList,
  siteList,
  contactList,
  createNewHaul,
  editHaul,
  modalFunction,
  createOrEditHaulModalToggle,
  haulDetailModalToggle,
  showConfirmEditModal,
  isProcoreAvailable,
  procoreCostCodes,
  haulDetail: {
    _id,
    haulType,
    haulId,
    pickUpSite,
    dropOffSite,
    project,
    materials,
    poNumber,
    siteContact,
    superIntendant,
    quantity,
    driverConfirmMaterial,
    driverEnterWeight,
    driverCaptureTicket,
    notes,
    procoreCostCode
  } = {}
}) => {
  const [step, setStep] = useState(viewStep || 0) //0, 1, 2

  const handleBackOrCancelClick = () => {
    if (step !== 0) {
      return setStep(step - 1)
    }
    if (modalFunction === 'edit' && step === 0) {
      haulDetailModalToggle(_id)
      createOrEditHaulModalToggle()
    }
    if (step === 0) {
      createOrEditHaulModalToggle()
    }
  }

  const handleNextButtonClick = () => {
    // TODO: Replace when Haul step 2 is added
    // if (step !== 2) {
    if (step !== 1) {
      return setStep(step + 1)
    }
  }

  const saveHaul = submitForm => {
    if (modalFunction === 'new') {
      return submitForm()
    }

    showConfirmEditModal(submitForm)
  }

  const addOrEditHaul = values => {
    const {
      haulType,
      project,
      pickUpSite,
      dropOffSite,
      siteContact,
      superIntendant,
      quantity
    } = values

    const haulValues = { ...values }

    haulValues.haulType = haulType.value
    haulValues.quantity = { defaultMaterialQuantity: quantity.value }
    haulValues.project = projectList.find(projectObj => projectObj._id === project.value)
    haulValues.pickUpSite = siteList.find(site => site._id === pickUpSite.value)
    haulValues.dropOffSite = siteList.find(site => site._id === dropOffSite.value)
    haulValues.siteContact = contactList.find(contact => contact._id === siteContact.value)
    haulValues.superIntendant = contactList.find(contact => contact._id === superIntendant.value)
    haulValues.materials = values.materials.map(mat => mat.value)

    // temp for 1 material type per haul
    haulValues.material = values.materials[0].label
    const materialVolume = materialList.find(item => item._id === values.materials[0].value)
    haulValues.volume = materialVolume.triaxleTruck ? materialVolume.triaxleTruck.toString() : '0'

    if (modalFunction === 'edit') {
      haulValues._id = _id
      return editHaul(haulValues)
    }
    createNewHaul(haulValues)
  }

  const handleMaterialClick = (option, values, setFieldValue) => {
    if (values.materials.find(v => v.value === option.value)) {
      setFieldValue('materials', [{ value: ' ', label: ' ' }])
    } else {
      setFieldValue('materials', [option])
    }

    // not yet implemented
    // If the option is already selected, remove it, otherwise add it ()
    // if (values.materials.find(v => v.value === option.value)) {
    //   setFieldValue(
    //     'materials',
    //     values.materials.length === 1
    //       ? [{ value: ' ', label: ' ' }]
    //       : values.materials.filter(v => v.value !== option.value)
    //   )
    // } else {
    //   values.materials[0].value === ' '
    //     ? setFieldValue('materials', [option])
    //     : setFieldValue('materials', [...values.materials, option])
    // }
  }

  const quantityInitialValue =
    modalFunction === 'edit'
      ? quantity && quantity.defaultMaterialQuantity
        ? { value: true, label: 'Default' }
        : { value: false, label: 'From Ticket' }
      : { value: ' ', label: ' ' }

  const materialsInitialValue =
    modalFunction === 'edit'
      ? materials.map(id => {
          const materialObj = materialList.find(material => material._id === id)
          return { value: id, label: materialObj.materialName }
        })
      : [{ value: ' ', label: ' ' }]

  return (
    <CreateNewModal
      title={modalFunction === 'edit' ? 'Edit Haul' : 'New Haul'}
      handleCloseModal={createOrEditHaulModalToggle}
      // TODO: Add step 2 heading to bannerText when it's added
      bannerText={step === 0 ? 'General Details' : 'Additional Details'}
      // Step {step + 1} of 3
      bannerTextRight={`Step ${step + 1} of 2`}
    >
      <Formik
        enableReinitialize={false}
        initialValues={{
          haulType:
            modalFunction === 'edit'
              ? {
                  value: haulType,
                  label:
                    haulType === 'export'
                      ? 'I am exporting materials offsite'
                      : 'I am importing materials onsite'
                }
              : { value: ' ', label: ' ' },
          haulId: modalFunction === 'edit' ? haulId : '',
          pickUpSite:
            modalFunction === 'edit'
              ? {
                  value: pickUpSite._id,
                  label: pickUpSite.siteName
                }
              : { value: ' ', label: ' ' },
          dropOffSite:
            modalFunction === 'edit'
              ? {
                  value: dropOffSite._id,
                  label: dropOffSite.siteName
                }
              : { value: ' ', label: ' ' },
          notes: modalFunction === 'edit' ? notes : '',
          project:
            modalFunction === 'edit'
              ? { value: project._id, label: project.projectName }
              : { value: ' ', label: ' ' },
          materials: materialsInitialValue,
          poNumber: modalFunction === 'edit' ? poNumber : '',
          siteContact:
            modalFunction === 'edit'
              ? {
                  value: siteContact._id,
                  label: `${siteContact.firstName} ${siteContact.lastName}`
                }
              : { value: ' ', label: ' ' },
          superIntendant:
            modalFunction === 'edit'
              ? {
                  value: superIntendant._id,
                  label: `${superIntendant.firstName} ${superIntendant.lastName}`
                }
              : { value: ' ', label: ' ' },
          driverConfirmMaterial: modalFunction === 'edit' ? driverConfirmMaterial || false : false,
          driverEnterWeight: modalFunction === 'edit' ? driverEnterWeight || false : false,
          driverCaptureTicket: modalFunction === 'edit' ? driverCaptureTicket || false : false,
          quantity: quantityInitialValue,
          procoreCostCode: isProcoreAvailable
            ? modalFunction === 'edit'
              ? procoreCostCode.full_code || ''
              : { value: ' ', label: ' ' }
            : undefined
          // driverInstructions: []
          // driverInstructions: ['confirmMaterial', 'enterWeight', 'captureTicket']
        }}
        validationSchema={HaulSchema}
        handleSubmit={e => console.log(e)}
        onSubmit={values => {
          addOrEditHaul(values)
        }}
        render={({
          values,
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          submitForm,
          isSubmitting,
          setFieldValue,
          setFieldTouched
        }) => (
          <form>
            <WidgetContent
              style={{
                height: '355px',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: 0,
                overflowY: 'scroll',
                overflowX: 'hidden'
              }}
            >
              {step === 0 && (
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ padding: '0 30px' }}>
                    <FormInputGroup>
                      <Select
                        className="fullWidthSelectBox optionsFullWidth"
                        activeOption={{
                          value: values.haulType.value,
                          label: values.haulType.label
                        }}
                        name="haulType"
                        label="Haul Type"
                        options={[
                          {
                            value: 'export',
                            label: 'I am exporting materials offsite'
                          },
                          {
                            value: 'import',
                            label: 'I am importing materials onsite'
                          }
                        ]}
                        menuPosition="bottom-left"
                        onOptionClick={e => setFieldValue('haulType', e, false)}
                        onBlur={() =>
                          setTimeout(() => {
                            setFieldTouched('haulType')
                          }, 500)
                        }
                      />
                      <ErrorMessage
                        name="haulType"
                        render={msg => (
                          <span
                            style={{
                              position: 'relative',
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg.value}
                          </span>
                        )}
                      />
                    </FormInputGroup>

                    <FormInputGroup direction="horizontal">
                      <div style={{ marginTop: '10px' }}>
                        <TextField
                          className="halfWidthInputBox"
                          label="Haul ID"
                          name="haulId"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.haulId}
                          maxLength={20}
                        />
                        <ErrorMessage
                          name="haulId"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </div>
                      <div style={{ marginTop: '10px' }}>
                        <Select
                          className="projecProvinceSelect optionsFullWidth"
                          activeOption={{
                            value: values.project.value,
                            label: values.project.label
                          }}
                          label="Project"
                          options={projectList.map(project => {
                            return {
                              value: project._id,
                              label: project.projectName
                            }
                          })}
                          menuPosition="bottom-left"
                          name="project"
                          onOptionClick={e => setFieldValue('project', e)}
                          onBlur={() =>
                            setTimeout(() => {
                              setFieldTouched('project')
                            }, 500)
                          }
                        />
                        <ErrorMessage
                          name="project"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </div>
                    </FormInputGroup>
                    <FormInputGroup>
                      <div style={{ paddingTop: '30px' }}>
                        <Select
                          className="fullWidthSelectBox optionsFullWidth"
                          activeOption={{
                            value: values.pickUpSite.value,
                            label: values.pickUpSite.label
                          }}
                          options={siteList.map(site => {
                            const { siteName } = site
                            return {
                              value: site._id,
                              label: siteName
                            }
                          })}
                          name="pickUpSite"
                          label="Pick Up Site"
                          menuPosition="bottom-left"
                          onBlur={() => setFieldTouched('pickUpSite')}
                          onOptionClick={e => setFieldValue('pickUpSite', e)}
                        />
                        <ErrorMessage
                          name="pickUpSite"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </div>
                    </FormInputGroup>
                    <FormInputGroup>
                      <div style={{ paddingTop: '10px' }}>
                        <Select
                          className="fullWidthSelectBox optionsFullWidth"
                          activeOption={{
                            value: values.dropOffSite.value,
                            label: values.dropOffSite.label
                          }}
                          options={siteList.map(site => {
                            const { siteName } = site
                            return {
                              value: site._id,
                              label: siteName
                            }
                          })}
                          name="dropOffSite"
                          label="Drop Off Site"
                          menuPosition="bottom-left"
                          onBlur={() => setFieldTouched('dropOffSite')}
                          onOptionClick={e => setFieldValue('dropOffSite', e)}
                        />
                        <ErrorMessage
                          name="dropOffSite"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </div>
                    </FormInputGroup>

                    <FormInputGroup direction="horizontal">
                      <div style={{ paddingTop: '30px' }}>
                        <Select
                          multiple
                          className="projecProvinceSelect multi-select optionsFullWidth"
                          activeOption={values.materials}
                          label="Material"
                          options={materialList.map(material => {
                            return {
                              value: material._id,
                              label: material.materialName
                            }
                          })}
                          menuPosition="bottom-left"
                          name="materials"
                          onOptionClick={option =>
                            handleMaterialClick(option, values, setFieldValue)
                          }
                          onBlur={() => setFieldTouched('materials')}
                        />
                        <ErrorMessage
                          name="materials"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg[0].value}
                            </span>
                          )}
                        />
                      </div>
                      <div style={{ paddingTop: '30px' }}>
                        <Select
                          className="projecProvinceSelect optionsFullWidth"
                          activeOption={values.quantity}
                          label="Quantity"
                          options={[
                            {
                              value: true,
                              label: 'Default'
                            },
                            {
                              value: false,
                              label: 'From Ticket'
                            }
                          ]}
                          menuPosition="bottom-left"
                          name="quantity"
                          onOptionClick={option => setFieldValue('quantity', option)}
                          onBlur={() => setFieldTouched('quantity')}
                        />
                        <ErrorMessage
                          name="quantity"
                          render={msg => (
                            <span
                              style={{
                                position: 'relative',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                      </div>
                    </FormInputGroup>

                    {isProcoreAvailable && procoreCostCodes && (
                      <div style={{ paddingTop: '30px' }}>
                        <FormInputGroup>
                          <Select
                            className="fullWidthSelectBox optionsFullWidth"
                            activeOption={{
                              value: values.procoreCostCode.value,
                              label: values.procoreCostCode.label
                            }}
                            name="procoreCostCode"
                            label="Procore Cost Code"
                            searchable
                            options={
                              procoreCostCodes &&
                              procoreCostCodes.map(item => ({
                                value: item,
                                label: item.full_code
                              }))
                            }
                            menuPosition="bottom-left"
                            onOptionClick={e => setFieldValue('procoreCostCode', e, false)}
                            onBlur={() =>
                              setTimeout(() => {
                                setFieldTouched('procoreCostCode')
                              }, 500)
                            }
                          />
                          <ErrorMessage
                            name="procoreCostCode"
                            render={msg => (
                              <span
                                style={{
                                  position: 'relative',
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg.value}
                              </span>
                            )}
                          />
                        </FormInputGroup>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* TODO: Change step when adding step 2 in */}
              {step === -1 && (
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ padding: '0 30px' }}>
                    <Toggle
                      label="Confirm Material"
                      name="driverConfirmMaterial"
                      description="The driver will be asked to confirm the material for each load"
                      onChange={e => {
                        setFieldValue('driverConfirmMaterial', !values.driverConfirmMaterial)
                      }}
                      value={values.driverConfirmMaterial}
                      defaultChecked={values.driverConfirmMaterial}
                      disabled={modalFunction === 'view'}
                    />
                    <Toggle
                      label="Enter weight"
                      description="The driver will be asked to enter the weight of each load"
                      disabled={modalFunction === 'view'}
                      onChange={e => {
                        setFieldValue('driverEnterWeight', !values.driverEnterWeight)
                      }}
                      value={values.driverEnterWeight}
                      defaultChecked={values.driverEnterWeight}
                    />
                    <Toggle
                      label="Capture Ticket"
                      description="The driver will be asked to take aphoto of each ticket (beta)"
                      disabled={modalFunction === 'view'}
                      onChange={e => {
                        setFieldValue('driverCaptureTicket', !values.driverCaptureTicket)
                      }}
                      value={values.driverCaptureTicket}
                      defaultChecked={values.driverCaptureTicket}
                    />
                  </div>
                  <div style={{ padding: '30px' }}>
                    <div>
                      <span className="uik-content-title__wrapper">
                        ADDITIONAL INSTRUCTIONS FOR DRIVER (OPTIONAL)
                      </span>
                    </div>
                    <textarea
                      className="fullWidthInputBox uik-input__input"
                      label="Notes"
                      name="notes"
                      style={{ height: '118px', resize: 'none' }}
                      value={values.notes}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>
              )}

              {/* TODO: Replace with step 2 when it's added */}
              {step === 1 && (
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ padding: '0 30px' }}>
                    <FormInputGroup>
                      <TextField
                        className="fullWidthInputBox"
                        label="PO Number"
                        name="poNumber"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.poNumber}
                      />
                      <ErrorMessage
                        name="poNumber"
                        render={msg => (
                          <span
                            style={{
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg}
                          </span>
                        )}
                      />
                    </FormInputGroup>

                    <FormInputGroup>
                      <div style={{ paddingTop: '30px' }}>
                        <Select
                          className="fullWidthSelectBox optionsFullWidth"
                          activeOption={{
                            value: values.siteContact.value,
                            label: values.siteContact.label
                          }}
                          label="Site Contact"
                          options={contactList.map(contact => {
                            const { firstName, lastName } = contact
                            return {
                              value: contact._id,
                              label: `${firstName} ${lastName}`
                            }
                          })}
                          menuPosition="bottom-left"
                          name="siteContact"
                          onBlur={() => setFieldTouched('siteContact')}
                          onOptionClick={e => setFieldValue('siteContact', e)}
                        />
                        <ErrorMessage
                          name="siteContact"
                          render={msg => (
                            <span
                              style={{
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg.value}
                            </span>
                          )}
                        />
                        <div style={{ paddingTop: '10px' }}>
                          <Select
                            className="fullWidthSelectBox optionsFullWidth"
                            activeOption={{
                              value: values.superIntendant.value,
                              label: values.superIntendant.label
                            }}
                            label="Superintendent"
                            options={contactList.map(contact => {
                              const { firstName, lastName } = contact
                              return {
                                value: contact._id,
                                label: `${firstName} ${lastName}`
                              }
                            })}
                            name="superIntendant"
                            menuPosition="bottom-left"
                            onOptionClick={e => setFieldValue('superIntendant', e)}
                            onBlur={() => setFieldTouched('superIntendant')}
                          />
                          <ErrorMessage
                            name="superIntendant"
                            render={msg => (
                              <span
                                style={{
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg.value}
                              </span>
                            )}
                          />
                        </div>
                      </div>
                    </FormInputGroup>
                  </div>
                </div>
              )}
            </WidgetContent>
            <div style={{ display: 'flex' }}>
              <WidgetContent
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  border: 'none',
                  width: '482px'
                }}
              >
                <div style={{ width: '83px' }}>
                  <ModalButton
                    buttonStyle="tertiary"
                    name={step === 0 ? 'Cancel' : 'Back'}
                    onClick={handleBackOrCancelClick}
                  />
                </div>
                <div style={{ width: '83px' }}>
                  <ModalButton
                    success
                    disabled={isSubmitting}
                    name={step !== 1 ? 'Next' : 'Save'}
                    onClick={step === 1 ? () => saveHaul(submitForm) : handleNextButtonClick}
                    // TODO: Replace below when step 2 is added
                    // name={step !== 2 ? 'Next' : 'Save'}
                    // onClick={step === 2 ? handleSubmit : handleNextButtonClick}
                  />
                </div>
              </WidgetContent>
            </div>
          </form>
        )}
      />
    </CreateNewModal>
  )
}

export default CreateOrEditHaul

const HaulSchema = Yup.object().shape({
  haulType: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  haulId: Yup.string()
    .min(4, 'Min 4 digits')
    .max(20, 'Max 20 digits')
    .required('Required'),
  pickUpSite: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  dropOffSite: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  startDateTime: Yup.string(),
  endDateTime: Yup.string(),
  project: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  }),
  materials: Yup.array().of(
    Yup.object().shape({
      value: Yup.string()
        .trim()
        .required('Required')
    })
  ),
  trucksRequired: Yup.number()
    .min(1, 'Too Short!')
    .max(100, 'Too Long!'),
  // .required('Required'),
  truckType: Yup.string(),
  // .min(2, 'Too Short!')
  // .max(30, 'Too Long!')
  // .required('Required'),
  quantity: Yup.object().shape({
    value: Yup.string()
      .trim()
      .required('Required')
  })
})
